import * as Styles from "@faire/retailer-visitor-shared/app/(app)/retailer/[locale]/(pagesWithModal)/(defaultHeader)/search/loading.css";
import { ProductTileLoadingSkeleton } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/ProductTileLoadingSkeleton";
import { LoadingSkeleton } from "@faire/web--source/slate/LoadingSkeleton";
import React from "react";

const NUM_OF_PRODUCTS = 12;
const NUM_OF_FILTER_PILLS = 2;

export const LoggedInSearchLoadingSkeleton = () => {
  return (
    <div className={Styles.Wrapper}>
      {/* Filter Pills */}
      <FilterPillsLoadingList />

      {/* Product Tiles */}
      <ProductTilesLoadingSkeletonGrid />
    </div>
  );
};

export const ProductTilesLoadingSkeletonGrid = () => {
  return (
    <div className={Styles.ProductTileWrapper}>
      <div className={Styles.ExpandedProductTileGrid}>
        {Array.from({ length: NUM_OF_PRODUCTS }).map((_, index) => (
          <ProductTileLoadingSkeleton key={index} />
        ))}
      </div>
    </div>
  );
};

export const FilterPillsLoadingList = () => {
  return (
    <div className={Styles.FilterPillRow}>
      {Array.from({ length: NUM_OF_FILTER_PILLS }).map((_, index) => (
        <FilterPill key={index} />
      ))}
    </div>
  );
};

export const SearchPageFooterPlaceholder = () => {
  return <div className={Styles.SearchPageFooterPlaceholder}></div>;
};

const FilterPill = () => {
  return <LoadingSkeleton width="100px" height="40px" borderRadius="20px" />;
};
